
import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { useSignInWithEmailAndPassword } from 'react-firebase-hooks/auth';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import auth from '../../firebase.init';
import Loading from '../Loading/Loading';
import SocialLogin from '../SocialLogin/SocialLogin';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';





const Login = () => {
     const location = useLocation();
     const navigate = useNavigate();
     let from = location.state?.from?.pathname || "/";


     const [
          signInWithEmailAndPassword,
          user,
          loading,
          error,
     ] = useSignInWithEmailAndPassword(auth);



     if (user) {
          navigate(from, { replace: true });
          // navigate('/')

     }

     if (loading) {
          return <Loading></Loading>
     }



     let errorElement;
     if (error) {

          (errorElement = <p className='text-danger'>Error: {error.message}</p>)
     }


     const handleLogin = event => {
          event.preventDefault();
          const email = event.target.email.value;
          const password = event.target.password.value;
          signInWithEmailAndPassword(email, password);
          toast('yes completed now');

     }


     return (
          <div className='my-5'>
               <h2 className='text-center mb-3'>Please Login Now</h2>

               <div className='w-50 mx-auto'>
                    <Form onSubmit={handleLogin}>
                         <Form.Group className="mb-3" controlId="formBasicEmail">
                              <Form.Control type="email" name="email" placeholder="Enter email" />
                         </Form.Group>
                         <Form.Group className="mb-3" controlId="formBasicPassword">
                              <Form.Control type="password" name="password" placeholder="Password" />
                         </Form.Group>
                         <p>{errorElement}</p>
                         <Button className='w-50 mb-3' variant="primary" type="submit">
                              Submit
                         </Button><br />
                         <SocialLogin></SocialLogin>
                    </Form>
                    <Link to='/register'>
                         <p className='my-2 text-decoration-none' >Please Go Register Page</p>
                    </Link>

                    <ToastContainer></ToastContainer>
               </div>
          </div>
     );
};

export default Login;